import React, {Component} from "react";
import {connect} from "react-redux";
import {IconButton, Stack, Tooltip} from "@mui/material";
import {morphleBaseTheme1} from "../themes";
import CalendarViewMonthIcon from "@mui/icons-material/CalendarViewMonth";
import {mapTileSlideToProps} from "../../../redux_reducers/utils";
import {getFullScanShapeInPixels, mapMotorToCanvas} from "../utils/map_utils";
import {getPrefixedUrl, openInNewTab} from "../../../utils/utils";
import {get} from "../../../helper/request";
import axios from "axios";
import {error_manager} from "../../../helper/error_manager";
import {aclPermissions} from "../../../const/ACLPermissions";

class SwitchToTileView extends Component {

    fetch = () => new Promise((resolve, reject) => {
        const fetchPathUnitMap = get(getPrefixedUrl('/inter-process/pathunitmap.json', this.props.slide));
        const fetchDeviceSettings = get(getPrefixedUrl('/meta/device_settings.json', this.props.slide));
        axios.all([fetchPathUnitMap, fetchDeviceSettings])
            .then(axios.spread((fetchPathUnitMap, fetchDeviceSettings) => resolve([fetchPathUnitMap, fetchDeviceSettings])))
            .catch(error => {
                let url = `/gamma${window.location.href.split("gamma")[1]}?#?tileMapEnable=true&topApp=${aclPermissions.tile_view_app}`;
                openInNewTab(url)
                error_manager("Map to tile-viewer data absent", error)
            });
    })

    handleViewChange = ([pathUnitMap, deviceSettings]) => {
        let {y_fields, tile_height, uperpixel} = this.props.slide;

        let x = this.props.slidemap.getView().getCenter()[0];
        let y = this.props.slidemap.getView().getCenter()[1];
        let x_index, y_index, minDistance = 10000000;
        const fullScanShapePxls = getFullScanShapeInPixels(this.props.slide);
        let baseCanvasY = fullScanShapePxls[1];
        Object.values(this.props.slide.txty).forEach(image => {
            let image_x = image.pos.X;
            let image_y = baseCanvasY - image.pos.Y;
            let distance = Math.sqrt((x - image_x) * (x - image_x) + (y - image_y) * (y - image_y));
            if (distance < minDistance) {
                minDistance = distance;
                x_index = image.x_index;
                y_index = image.y_index;
            }
        });
        y_index = y_index.split("_")[0];
        let key_ = 'x' + x_index + 'y' + y_index;
        let xPosition, yPosition, x_tile, y_tile;
        Object.values(pathUnitMap.scanCellMap).forEach(scanCell => {
            if (scanCell.key === key_) {
                xPosition = scanCell.position.xPosition;
                yPosition = scanCell.position.yPosition;
                let pos = mapMotorToCanvas(xPosition, yPosition, this.props.slide,
                    {device_settings: deviceSettings});
                x_tile = pos.x;
                y_tile = pos.y;
                y_tile = y_fields * tile_height * uperpixel - y_tile;
            }
        });
        let url = `/gamma${window.location.href.split("gamma")[1]}?`;
        for (let mapId in this.props.mapsState) {
            let mapState = this.props.mapsState[mapId];
            url += `slideId=${mapState.slide.id || mapState.slideId}&x=${x_tile}&y=${y_tile}&z=${mapState.z}&r=${mapState.r}&digitalZoomStatus=${mapState.digitalZoomStatus}#`;
        }
        let {gammaState} = this.props;
        url += `?sync=${gammaState.sync}&activeMapId=${gammaState.activeMapId}&tileMapEnable=true&topApp=${aclPermissions.tile_view_app}&bottomApp=${gammaState.bottomApp.id}`;
        return openInNewTab(url);

    }

    render() {

        let isDisabled = this.props.tileMapEnable;

        return <Stack direction={"row"} spacing={1} justifyContent="flex-start" sx={{alignItems: 'center'}}>
            <Tooltip title={isDisabled ? "Switch Disabled" : "Switch to TileView"} placement={"bottom"}>
                <IconButton size="small" onClick={() => this.fetch().then(this.handleViewChange)} disabled={isDisabled}>
                    <CalendarViewMonthIcon
                        sx={{color: morphleBaseTheme1.palette.headBarIcon.primary, opacity: isDisabled ? 0.6 : 1}}/>
                </IconButton>
            </Tooltip>
        </Stack>
    }
}

export default connect(mapTileSlideToProps)(SwitchToTileView);
